import React from "react";

import ScrollButtonView from "../scrollButtonView";
import FilterContentHolderButton from './filterContentHolderButton';

export default class FilterContentHolder extends React.Component {
  render() {
    return (
      <div className="main-filter-fx" id="filter-content-holder">
        <div className="main-filter-wrapper">

          <ScrollButtonView direction="up" elementToScroll=".filter-content"/>
          <div className="filter-content">
            {this.props.items}
          </div>
          <ScrollButtonView direction="down" elementToScroll=".filter-content"/>

          <div className="filter-accept-button-wrapper">
            {<FilterContentHolderButton type="accept" click={(type) => this.props.acceptClick(type)}/>}
            {<FilterContentHolderButton type="reset" click={(type) => this.props.resetClick(type)}/>}
          </div>
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/stones/filterContentHolder.js